import { translations } from "../../Translation/staticTranslation"

const lang = localStorage.getItem("language") || "ar"
const bulkupload = translations[lang]?.productPage?.bulk_upload_page

export const BulkUploadActions = (
  handleDeleteuploadedFile,
  deleteLoading,
  handleViewLogs
) => {
  return [
    {
      switch: (row) => (
        <>
          {/* <Switch
            checked={row.is_active}
            className="custom-switch mr-20"
            onChange={(status) => {
              if(!updateLoading){
                message.warning("Please wait while the product is being updated");
                handleUpdateProduct("", "", row, status);
              }
            }} 
          />*/}
        </>
      ),
      type: "switch",
    },
    {
      text: bulkupload?.view_summary,
      className: "view-add-comments",
      onClick: (row) => handleViewLogs(row),
      type: "text",
      // Show view summary for all statuses except pending (status 1)
      condition: (row) => row.file_status !== 1,
    },
    {
      icon: "/store/trash.svg",
      className: `delete ${deleteLoading && "not-allowed"}`,
      onClick: (row) => handleDeleteuploadedFile(row),
      type: "image",
      disabled: deleteLoading,
    },
  ]
}
